import React, {useEffect} from "react";
import {Link} from 'react-router-dom'
import {useFormContext} from "react-hook-form";

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CircularProgress from '@mui/material/CircularProgress';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as ValidationMessages from '../../constants/ValidationMessages';
import * as CustomStyles from '../../styles/CustomStyles';
import * as DataPattern from '../../constants/DataPattern';
import * as DateHelper from '../../util/DateHelper';
import * as Const from '../../constants/SystemConstants';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import { getRsvtiOperatorSelectData } from "../../util/TypeConvertor";
import {Loading} from '../../custom/LoadingComponent';
import { AuthzIscirImageType } from "../../constants/Consts";

import * as RestCall from '../../../utils/network/RestCalls';


//
// It is expected that <FormProvider> provides all the hook methods in the parent before calling the below components
// The components access the methods (register, formState, errors, etc...) by using useFormContext()
// lAuthorization is expected to be in the local form state
//


export function AuthorizationRsvtiOperator(props) {
    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    const [dateAuthorization, setDateAuthorization] = React.useState(dayjs(`${defaultValues.lAuthorization.autorizatie.dataAutorizatie}`));
    const [dateIssue, setDateIssue] = React.useState(dayjs(`${defaultValues.lAuthorization.autorizatie.dataEliberare}`));
    const [validUntil, setValidUntil] = React.useState(dayjs(`${defaultValues.lAuthorization.autorizatie.dataExpirare}`));

    const validateAuthorizationDate = (dataAuthorizationStr) => {
        if( DateHelper.isValidStringDateFmt(dataAuthorizationStr) ) {
            return true;
        }
        else {
            return 'Format data este invalid';
        }
    }

    const validateDataEliberareAutorizatie = (dataEliberareStr) => {
        if(dataEliberareStr){
            if( DateHelper.isValidStringDateFmt(dataEliberareStr) ) {
                const dataEliberare = DateHelper.getDateFromString(dataEliberareStr);
                if(dataEliberare < dateAuthorization) {
                    return 'Data Eliberare este inainte de Data Autorizatie';
                }
                else{
                    return true;
                }
            }
            else {
                return 'Format data este invalid';
            }    
        }
        else {
            return true;
        }
    }

    return(
        <React.Fragment>
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nr. Autorizatie" fullWidth margin="dense" 
                        {...register("lAuthorization.autorizatie.authNo", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lAuthorization?.autorizatie?.authNo}
                        helperText={errors?.lAuthorization?.autorizatie?.authNo ? errors.lAuthorization.autorizatie.authNo.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            disabled={!!props.disabled ? props.disabled : false}
                            label="Data Autorizatie"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dateAuthorization}
                            onChange={(newValue) => {
                                setDateAuthorization(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.autorizatie.dataAutorizatie', newValue.toISOString());

                                    const expiryDate = newValue.add(Const.AUTHORIZATION_EXPIRATION_YEARS, 'year');
                                    setValidUntil(expiryDate);
                                    setValue('lAuthorization.autorizatie.dataExpirare', expiryDate.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.autorizatie.dataAutorizatie', 
                                        {required: ValidationMessages.REQUITED_MESSAGE, 
                                        validate: vd => validateAuthorizationDate(vd) }
                                    )}
                                    error={!!errors?.lAuthorization?.autorizatie?.dataAutorizatie}
                                    helperText={errors?.lAuthorization?.autorizatie?.dataAutorizatie ? errors.lAuthorization.autorizatie.dataAutorizatie.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker disabled={false}
                            label="Valabila Pana La"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={validUntil}
                            onChange={(newValue) => {
                                setValidUntil(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.autorizatie.dataExpirare', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.autorizatie.dataExpirare', {required: ValidationMessages.REQUITED_MESSAGE})}
                                    error={!!errors?.lAuthorization?.autorizatie?.dataExpirare}
                                    helperText={errors?.lAuthorization?.autorizatie?.dataExpirare ? errors.lAuthorization.autorizatie.dataExpirare.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            /*disabled={!!props.disabled ? props.disabled : false}*/
                            label="Data Eliberare Autorizatie"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dateIssue}
                            onChange={(newValue) => {
                                setDateIssue(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.autorizatie.dataEliberare', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.autorizatie.dataEliberare', 
                                            {/*required: ValidationMessages.REQUITED_MESSAGE,*/ 
                                            validate: vd => validateDataEliberareAutorizatie(vd) }
                                    )}
                                    error={!!errors?.lAuthorization?.autorizatie?.dataEliberare}
                                    helperText={errors?.lAuthorization?.autorizatie?.dataEliberare ? errors.lAuthorization.autorizatie.dataEliberare.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={8}>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <CustomSelect 
                        selectId={'authzsStatus'} 
                        selectType={SelectTypes.AUTHORIZATION_STATUS} 
                        value={defaultValues.lAuthorization.autorizatie.status} 
                        register={{...register('lAuthorization.autorizatie.status', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lAuthorization?.autorizatie?.status}
                        helperText={errors?.lAuthorization?.autorizatie?.status ? errors.lAuthorization.autorizatie?.status.message : null}
                    />   
                </Grid>
                <Grid item xs={8}>
                </Grid>

            </Grid>
        </React.Fragment>
    );
}


function ViewImageModalDialog(props) {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [selectedImgKey, setSelectedImgKey] = React.useState(null);
    const [selectedImage, setSelectedImage] = React.useState(null);

    const handleClickOpen = async () => {
        setOpen(true);
        if(props.imageKey != selectedImgKey) {
            setIsLoading(true);
            await loadFileFromServer(props.imageKey);
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setOpen(false);
    };

    const loadFileFromServer = async (imageKey) => {
        const fileName = imageKey.split('/')[4];
        const imgType = fileName.split('.')[1];

        return await RestCall.fetchAuthzImage(imageKey)
            .then((blob) => {
                let metadata = {
                    type: `image/${imgType}`
                };
                let file = new File([blob], `${fileName}`, metadata);
                setSelectedImgKey(imageKey);
                setSelectedImage(file);
            })
    }

    return(
        <React.Fragment>

            <Link
                component="button"
                variant="body2"
                onClick={handleClickOpen}
            >
                {props.buttonName}
            </Link>

            <Dialog open={open} onClose={handleClose} maxWidth='md' >
                <DialogTitle>
                    View
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                
                <DialogContent dividers>

                    {isLoading || !selectedImage ? 
                            <Loading />
                            :
                        <Box
                            component="img"
                            sx={{
                                maxHeight: { xs: 700, md: 700 },
                            }}
                            alt="Imagine Autorizatie"
                            src={URL.createObjectURL(selectedImage)}
                        >    
                        </Box>
                    }

                </DialogContent>

            </Dialog>

        </React.Fragment>
    );
}


const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file)
        fileReader.onload = () => {
          resolve(fileReader.result);
        }
        fileReader.onerror = (error) => {
          reject(error);
        }
      })        
}


const downloadAuthzImage = async (imageKey) => {
    const fileName = imageKey.split('/')[4];

    return await RestCall.fetchAuthzImage(imageKey)
        .then((blob) => {
            // Create blob link to download
            const url = window.URL.createObjectURL(
                new Blob([blob]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `${fileName}`,
            );
        
            // Append to html link element page
            document.body.appendChild(link);
        
            // Start download
            link.click();
        
            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
        .catch(error => console.log(error));    
}


export function AuthorizationRsvtiStandard(props) {
    const { register, setValue, formState: { errors, defaultValues } } = useFormContext();

    const [dateAuthorization, setDateAuthorization] = React.useState(dayjs(`${defaultValues.lAuthorization.autorizatie.dataAutorizatie}`));
    const [dateIssue, setDateIssue] = React.useState(dayjs(`${defaultValues.lAuthorization.autorizatie.dataEliberare}`));

    const [isUploadingData, setIsUploadingData] = React.useState(false);

    const validateAuthorizationDate = (dataAuthorizationStr) => {
        if( DateHelper.isValidStringDateFmt(dataAuthorizationStr) ) {
            return true;
        }
        else {
            return 'Format data este invalid';
        }
    }

    const validateDataEliberareAutorizatie = (dataEliberareStr) => {
        if(dataEliberareStr){
            if( DateHelper.isValidStringDateFmt(dataEliberareStr) ) {
                const dataEliberare = DateHelper.getDateFromString(dataEliberareStr);
                if(dataEliberare < dateAuthorization) {
                    return 'Data Eliberare este inainte de Data Autorizatie';
                }
                else{
                    return true;
                }
            }
            else {
                return 'Format data este invalid';
            }    
        }
        else {
            return true;
        }
    }

    const uploadImage = async (imageToUpload) => {
        const imageBase64 = await convertFileToBase64(imageToUpload)
        setIsUploadingData(true);
        await props.saveAuthzImage(imageToUpload.name, 
                            imageBase64,  
                            defaultValues.employerId, 
                            defaultValues.employeeId, 
                            defaultValues.lAuthorization.id, 
                            AuthzIscirImageType.Authz);
        setIsUploadingData(false);
    }

    return(
        <React.Fragment>
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Nr. Autorizatie" fullWidth margin="dense" 
                        {...register("lAuthorization.autorizatie.authNo", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lAuthorization?.autorizatie?.authNo}
                        helperText={errors?.lAuthorization?.autorizatie?.authNo ? errors.lAuthorization.autorizatie.authNo.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ro'>
                        <DesktopDatePicker
                            label="Data Autorizatie"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            format={DataPattern.DATE_FORMAT_RO}
                            value={dateAuthorization}
                            onChange={(newValue) => {
                                setDateAuthorization( newValue );
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.autorizatie.dataAutorizatie', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.autorizatie.dataAutorizatie', 
                                        {required: ValidationMessages.REQUITED_MESSAGE,
                                        validate: vd => validateAuthorizationDate(vd)}
                                    )}
                                    error={!!errors?.lAuthorization?.autorizatie?.dataAutorizatie}
                                    helperText={errors?.lAuthorization?.autorizatie?.dataAutorizatie ? errors.lAuthorization.autorizatie.dataAutorizatie.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={4}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Data Eliberare Autorizatie"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dateIssue}
                            onChange={(newValue) => {
                                setDateIssue(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.autorizatie.dataEliberare', newValue.toISOString());
                                }
                             }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.autorizatie.dataEliberare', 
                                        {/*required: ValidationMessages.REQUITED_MESSAGE,*/ 
                                         validate: vd => validateDataEliberareAutorizatie(vd) }
                                    )}
                                    error={!!errors?.lAuthorization?.autorizatie?.dataEliberare}
                                    helperText={errors?.lAuthorization?.autorizatie?.dataEliberare ? errors.lAuthorization.autorizatie.dataEliberare.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>

                {/*row*/}
                <Grid item xs={2}>
                    <TextField variant="standard" size="small" label="Clasa" fullWidth margin="dense" 
                        {...register("lAuthorization.autorizatie.clasa")} 
                        error={!!errors?.lAuthorization?.autorizatie?.clasa}
                        helperText={errors?.lAuthorization?.autorizatie?.clasa ? errors.lAuthorization.autorizatie.clasa.message : null}
                    />
                </Grid>
                <Grid item xs={2}>
                    <TextField variant="standard" size="small" label="Grupa" fullWidth margin="dense" 
                        {...register("lAuthorization.autorizatie.grupa")} 
                        error={!!errors?.lAuthorization?.autorizatie?.grupa}
                        helperText={errors?.lAuthorization?.autorizatie?.grupa ? errors.lAuthorization.autorizatie.grupa.message : null}
                    />
                </Grid>
                <Grid item xs={4}>
                </Grid>
                <Grid item xs={2}>
                    <CustomSelect 
                        selectId={'authzsStatus'} 
                        selectType={SelectTypes.AUTHORIZATION_STATUS} 
                        value={defaultValues.lAuthorization.autorizatie.status} 
                        register={{...register('lAuthorization.autorizatie.status', {required: ValidationMessages.REQUITED_MESSAGE})}}
                        error={!!errors?.lAuthorization?.autorizatie?.status}
                        helperText={errors?.lAuthorization?.autorizatie?.status ? errors.lAuthorization.autorizatie?.status.message : null}
                    />   
                </Grid>
                <Grid item xs={2}>
                </Grid>

                {/* Display the file upload setion only for existing Authorizations */}
                {defaultValues.lAuthorization.id && (
                    <React.Fragment>
                        {/*row*/}
                        <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
                            {defaultValues.lAuthorization.imgAuthzKey && (              
                                <React.Fragment key="authzUploadDownload">
                                    <ViewImageModalDialog 
                                        buttonName={'View'} 
                                        imageKey = {defaultValues.lAuthorization.imgAuthzKey}
                                    />
                                    &nbsp;&nbsp;&nbsp;
                                    <Link onClick={() => downloadAuthzImage(defaultValues.lAuthorization.imgAuthzKey)}>Download <FileDownloadIcon /></Link>
                                </React.Fragment>
                            )}
                        </Grid>
                        <Grid item xs={8}>
                            <label htmlFor="upload-authz-photo">
                                <input
                                    type="file" accept="image/jpeg, image/png"
                                    id="upload-authz-photo"
                                    name="upload-authz-photo"
                                    style={{ display: 'none' }}
                                    onChange={(event) => {
                                        uploadImage(event.target.files[0]);
                                    }}
                                />
                                <Box sx={{ m: 1, position: 'relative' }}>
                                    <Button color="primary" variant="contained" component="span" disabled={isUploadingData}>
                                        Incarca
                                    </Button> (.jpeg, .png)
                                    {isUploadingData && (
                                        <CircularProgress 
                                            size={25} 
                                            sx={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>
                            </label>
                        </Grid>
                    </React.Fragment>
                )}

            </Grid>
        </React.Fragment>
    );
}

const getCouponFirstStampYear = (couponDate, isOldModel) => {
    if(couponDate.isValid()) {
        return couponDate.year() + (isOldModel ? 1 : 0);
    }
    else {
        return 1;
    }
}

export function AuthorizationRsvtiTalon(props) {
    const { register, setValue, getValues, formState: { errors, defaultValues } } = useFormContext();

    const [checkedOldModel, setCheckedOldModel] = React.useState(defaultValues.lAuthorization.talon?.oldModel ? defaultValues.lAuthorization.talon.oldModel : false);
    const [dataEliberareTalonValue, setDataEliberareTalonValue] = React.useState(dayjs(`${defaultValues.lAuthorization?.talon?.dataEliberareTalon}`));
    const [dataScadentaTalonValue, setDataScadentaTalonValue] = React.useState(dayjs(`${defaultValues.lAuthorization?.talon?.dataScadentaTalon}`));
    const [talonVizaFirsYear, setTalonVizaFirstYearValue] = React.useState( getCouponFirstStampYear(dataEliberareTalonValue, checkedOldModel) );
    const [dataVizaTalonAn1, setDataVizaTalonAn1Value] = React.useState(dayjs(`${defaultValues.lAuthorization?.talon?.dataVizaTalonAn1}`));
    const [dataVizaTalonAn2, setDataVizaTalonAn2Value] = React.useState(dayjs(`${defaultValues.lAuthorization?.talon?.dataVizaTalonAn2}`));
    const [dataVizaTalonAn3, setDataVizaTalonAn3Value] = React.useState(dayjs(`${defaultValues.lAuthorization?.talon?.dataVizaTalonAn3}`));
    const [dataVizaTalonAn4, setDataVizaTalonAn4Value] = React.useState(dayjs(`${defaultValues.lAuthorization?.talon?.dataVizaTalonAn4}`));

    const [selectedRsvtiOperatorId, setSelectedRsvtiOperatorId] = React.useState( defaultValues.lAuthorization?.talon?.operatorRsvtiUname!=null ? defaultValues.lAuthorization.talon.operatorRsvtiUname : '' );
    const rsvtiOperatorSelectData = getRsvtiOperatorSelectData(props.rsvtiOperators);

    const [isUploadingData, setIsUploadingData] = React.useState(false);

    const uploadImage = async (imageToUpload) => {
        const imageBase64 = await convertFileToBase64(imageToUpload)
        setIsUploadingData(true);
        await props.saveAuthzImage(imageToUpload.name, 
                            imageBase64,  
                            defaultValues.employerId, 
                            defaultValues.employeeId, 
                            defaultValues.lAuthorization.id, 
                            AuthzIscirImageType.Coupon);
        setIsUploadingData(false);
    }

    const validateDataEliberareTalon = (dataEliberareTalon) => {
        if( DateHelper.isValidStringDateFmt(dataEliberareTalon) ) {
            const dataTalon = DateHelper.getDateFromString(dataEliberareTalon);
            const dataAutorizatie = DateHelper.getDateFromString(getValues('lAuthorization.autorizatie.dataAutorizatie'));
            if(dataTalon < dataAutorizatie) {
                return 'Data Eliberare Talon este inainte de Data Autorizatie';
            }
            else{
                return true;
            }
        }
        else {
            return 'Format data este invalid';
        }
    }

    const validateStampDateFmt = (stampDate, vizaNo) => {
        if(stampDate) {
            if( DateHelper.isValidStringDateFmt(stampDate) ) {
                const anViza = DateHelper.getDateFromString(stampDate).year();
                if(anViza != talonVizaFirsYear + vizaNo) {
                    return 'Viza trebuie sa fie pentru ' + (talonVizaFirsYear + vizaNo);
                }
                else {
                    return true;
                }
            }
            else {
                return 'Format data este invalid';
            }
        }
        else {
            return true;
        }
    }

    return(
        <React.Fragment>
            <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                <Grid item xs={12}>
                    <Divider textAlign="left">Talon</Divider>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <TextField variant="standard" size="small" label="Talon vize anuale seria" fullWidth margin="dense" 
                        {...register("lAuthorization.talon.talonSeria", {required: ValidationMessages.REQUITED_MESSAGE})} 
                        error={!!errors?.lAuthorization?.talon?.talonSeria}
                        helperText={errors?.lAuthorization?.talon?.talonSeria ? errors.lAuthorization?.talon?.talonSeria.message : null}
                    />
                </Grid>
                <Grid item xs={2}>
                    <FormControlLabel sx={{marginTop: 1}}
                        control={ 
                            <Checkbox
                                {...register('lAuthorization.talon.oldModel')}                         
                                checked={checkedOldModel} 
                                onChange={(event) => {
                                    setCheckedOldModel(event.target.checked);
                                    setTalonVizaFirstYearValue( getCouponFirstStampYear(dataEliberareTalonValue, event.target.checked) );
                                }}
                            /> 
                        } 
                        label="Model Vechi" 
                    />
                </Grid>
                <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Data Eliberare Talon"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dataEliberareTalonValue}
                            onChange={(newValue) => {
                                if(newValue && newValue.isValid()) {
                                    setDataEliberareTalonValue(newValue);
                                    setValue('lAuthorization.talon.dataEliberareTalon', newValue.toISOString());
                                    setTalonVizaFirstYearValue( getCouponFirstStampYear(newValue, checkedOldModel) );

                                    const expiryDate = newValue.add(Const.COUPON_EXPIRATION_YEARS, 'year');
                                    setDataScadentaTalonValue(expiryDate);
                                    setValue('lAuthorization.talon.dataScadentaTalon', expiryDate.toISOString());
                                }
                                else{
                                    const invalidDate = dayjs(null);
                                    setDataEliberareTalonValue(invalidDate);
                                    setTalonVizaFirstYearValue( getCouponFirstStampYear(invalidDate, checkedOldModel) );

                                    setDataScadentaTalonValue(invalidDate);
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.talon.dataEliberareTalon', 
                                        {required: ValidationMessages.REQUITED_MESSAGE, 
                                        validate: vd => validateDataEliberareTalon(vd) }
                                    )}
                                    error={!!errors?.lAuthorization?.talon?.dataEliberareTalon}
                                    helperText={errors?.lAuthorization?.talon?.dataEliberareTalon ? errors.lAuthorization?.talon?.dataEliberareTalon.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker disabled={true}
                            label="Data Scadenta Talon"
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dataScadentaTalonValue}
                            onChange={(newValue) => {
                                setDataScadentaTalonValue(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.talon.dataScadentaTalon', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                    {...register('lAuthorization.talon.dataScadentaTalon', {required: ValidationMessages.REQUITED_MESSAGE} )}
                                    error={!!errors?.lAuthorization?.talon?.dataScadentaTalon}
                                    helperText={errors?.lAuthorization?.talon?.dataScadentaTalon ? errors.lAuthorization?.talon?.dataScadentaTalon.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>

                {/*row*/}
                <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label={"Data viza " +`${talonVizaFirsYear}`}
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dataVizaTalonAn1}
                            onChange={(newValue) => {
                                setDataVizaTalonAn1Value(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.talon.dataVizaTalonAn1', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard"
                                    {...register('lAuthorization.talon.dataVizaTalonAn1', {validate: vd => validateStampDateFmt(vd, 0) })}
                                    error={!!errors?.lAuthorization?.talon?.dataVizaTalonAn1}
                                    helperText={errors?.lAuthorization?.talon?.dataVizaTalonAn1 ? errors.lAuthorization?.talon?.dataVizaTalonAn1.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label={"Data viza " +`${talonVizaFirsYear + 1}`}
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dataVizaTalonAn2}
                            onChange={(newValue) => {
                                setDataVizaTalonAn2Value(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.talon.dataVizaTalonAn2', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                {...register('lAuthorization.talon.dataVizaTalonAn2', {validate: vd => validateStampDateFmt(vd, 1) })}
                                error={!!errors?.lAuthorization?.talon?.dataVizaTalonAn2}
                                    helperText={errors?.lAuthorization?.talon?.dataVizaTalonAn2 ? errors.lAuthorization?.talon?.dataVizaTalonAn2.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label={"Data viza " +`${talonVizaFirsYear + 2}`}
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dataVizaTalonAn3}
                            onChange={(newValue) => {
                                setDataVizaTalonAn3Value(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.talon.dataVizaTalonAn3', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                {...register('lAuthorization.talon.dataVizaTalonAn3', {validate: vd => validateStampDateFmt(vd, 2) })}
                                error={!!errors?.lAuthorization?.talon?.dataVizaTalonAn3}
                                    helperText={errors?.lAuthorization?.talon?.dataVizaTalonAn3 ? errors.lAuthorization?.talon?.dataVizaTalonAn3.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label={"Data viza " +`${talonVizaFirsYear + 3}`}
                            inputFormat={DataPattern.DATE_FORMAT_RO}
                            value={dataVizaTalonAn4}
                            onChange={(newValue) => {
                                setDataVizaTalonAn4Value(newValue);
                                if(newValue && newValue.isValid()) {
                                    setValue('lAuthorization.talon.dataVizaTalonAn4', newValue.toISOString());
                                }
                            }}
                            renderInput={(params) => 
                                <TextField {...params} variant="standard" 
                                {...register('lAuthorization.talon.dataVizaTalonAn4', {validate: vd => validateStampDateFmt(vd, 3) })}
                                error={!!errors?.lAuthorization?.talon?.dataVizaTalonAn4}
                                    helperText={errors?.lAuthorization?.talon?.dataVizaTalonAn4 ? errors.lAuthorization?.talon?.dataVizaTalonAn4.message : null}
                                />
                            }
                        />
                    </LocalizationProvider>
                </Grid>

                {/*row*/}
                <Grid item xs={4}>
                    <FormControl fullWidth size="small" margin="dense" variant="standard">
                        <InputLabel id={'rsvtiOperator-inputLabelId'} error={!!errors?.lEmployee?.employmentDetails?.employerId}>Operator RSVTI</InputLabel>
                        <Select
                            {...register('lAuthorization.talon.operatorRsvtiUname', {required: ValidationMessages.REQUITED_MESSAGE})}
                            labelId={'rsvtiOp-selectLabelId'}
                            id={'rsvtiOperator'}
                            value={selectedRsvtiOperatorId}
                            onChange={(event) => {
                                setSelectedRsvtiOperatorId(event.target.value);
                            }}
                                label={'rsvtiOperator-label'}
                            error={!!errors?.lAuthorization?.talon?.operatorRsvtiUname}
                            >
                            {
                                rsvtiOperatorSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                            }
                        </Select>
                        <Typography sx={{ color: 'error.main', fontSize: 12 }}>{errors?.lAuthorization?.talon?.operatorRsvtiUname ? errors.lAuthorization.talon.operatorRsvtiUname.message : null}</Typography>
                    </FormControl>
                </Grid>
                <Grid item xs={8}>
                </Grid>

                {/*row*/}
                <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
                    {defaultValues.lAuthorization.imgTalonKey && (              
                        <React.Fragment key="authzUploadDownload">
                            <ViewImageModalDialog 
                                buttonName={'View'} 
                                imageKey = {defaultValues.lAuthorization.imgTalonKey}
                            />
                            &nbsp;&nbsp;&nbsp;
                            <Link onClick={() => downloadAuthzImage(defaultValues.lAuthorization.imgTalonKey)}>Download <FileDownloadIcon /></Link>
                        </React.Fragment>
                    )}
                </Grid>
                <Grid item xs={8}>
                    <label htmlFor="upload-coupon-photo">
                        <input
                            type="file"
                            id="upload-coupon-photo"
                            name="upload-coupon-photo"
                            style={{ display: 'none' }}
                            onChange={(event) => {
                                uploadImage(event.target.files[0]);
                            }}
                        />
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <Button color="primary" variant="contained" component="span" disabled={isUploadingData}>
                                Incarca
                            </Button> (.jpeg, .png)
                            {isUploadingData && (
                                <CircularProgress 
                                    size={25} 
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        marginTop: '-12px',
                                        marginLeft: '-12px',
                                      }}
                                />
                            )}
                        </Box>
                    </label>
                </Grid>
                
            </Grid>
        </React.Fragment>
    );
}
